import faClock from '@fortawesome/fontawesome-pro-light/faClock'
import faMagic from '@fortawesome/fontawesome-pro-light/faMagic'
import faForward from '@fortawesome/fontawesome-pro-light/faForward'
import faWindowClose from '@fortawesome/fontawesome-pro-light/faWindowClose'
import faUserAstronaut from '@fortawesome/fontawesome-pro-light/faUserAstronaut'

export default [{
  icon: faClock,
  title: 'Save time on typing',
  subTitle: 'Instantly type any number of pre-defined text blocks.'
}, {
    icon: faMagic,
    title: 'Open apps like magic',
    subTitle: 'Open your favorite apps faster than you can say &ldquo;Alohomora.&rdquo;'
  }, {
    icon: faForward,
    title: 'Take control of your media controls',
    subTitle: 'All the media controls you would expect on any keys you want them.'
  }, {
    icon: faWindowClose,
    title: 'Disable keys you don&rsquo;t want',
    subTitle: 'Accidently hitting the Windows key during your gaming sessions? Us too...'
  }, {
    icon: faUserAstronaut,
    title: 'More features in the works',
    subTitle: 'MajorKey really has limitless possibilities, these are some of the features we&rsquo;re planning on \
      bringing to the app in the near future:',
    subList: [{
      title: 'Custom macros'
    }, {
      title: 'Window management'
    }, {
      title: 'Power off & sleep'
    }, {
      title: 'Mouse controls'
    }]
}]


// WEBPACK FOOTER //
// ./src/data/features.js